module.exports = "<ng-content select=\"app-vid-question\"></ng-content>\r\n"